<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $t('messages.absenteeism'),
                        href: meta.links.absenteeism_index,
                    },
                    {
                        name: $t('messages.stats'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div>
            <NavLinks :links="meta.navLinks.schoolYears" />
        </div>

        <div v-for="graph in graphs">
            <apexchart :type="graph.chart.type" :height="graph.chart.height" :series="graph.series" :options="graph" />
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';

export default {
    components: {
        PanelPage,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'graphs'],
};
</script>
<script setup>
import NavLinks from '@/components/NavLinks.vue';
</script>
